import React from 'react';
import { Link } from 'react-router-dom';
import LegalLayout from './LegalLayout';

export default function AboutPage() {
  return (
    <LegalLayout
      title="About TelegramEmailBot"
      metaTitle="About Us | TelegramEmailBot"
      metaDescription="Learn about TelegramEmailBot — the easiest way to get email inside Telegram. Built by Mii Global Partner Holdings Sdn. Bhd. for hosts, teams, and businesses worldwide."
      canonicalPath="/about"
      testid="about-page"
    >
      <p>
        <strong>TelegramEmailBot</strong> turns Telegram into a real email system. We give you a unique email address that delivers every message straight to your Telegram chat or team group — no signup, no credit card, no separate inbox to check.
      </p>

      <h2>Why we built this</h2>
      <p>
        Email is still where business happens. CCTV cameras send motion alerts by email. Hotel platforms send booking notifications by email. CRMs, banks, suppliers, schools — they all rely on email. But teams already live in Telegram. Switching apps to check the inbox slows everything down and important messages get missed.
      </p>
      <p>
        TelegramEmailBot bridges the gap. The moment an email lands, it appears in Telegram. Everyone in the group sees it at the same time. Replies, attachments and AI summaries work out of the box.
      </p>

      <h2>Who uses TelegramEmailBot</h2>
      <ul>
        <li><strong>Property hosts and hotels</strong> routing Airbnb, Booking.com and Agoda alerts to their reception team</li>
        <li><strong>IT teams</strong> receiving server-down, UPS and printer alerts in their on-call channel</li>
        <li><strong>Sales and CRM teams</strong> capturing new leads the second a form is submitted</li>
        <li><strong>Accounts teams</strong> chasing overdue invoices and confirming payments without opening Outlook</li>
        <li><strong>Schools and HR teams</strong> receiving applications, attendance updates and resumes in one place</li>
      </ul>

      <h2>How we make money</h2>
      <p>
        Simple, transparent pricing — <strong>$4.99 one-time</strong> for a permanent inbox with 20 complimentary emails, or <strong>$14.99/year</strong> for unlimited emails plus AI summaries. That's it. No surprise add-ons, no per-seat charges. We keep pricing simple so the product stays focused.
      </p>

      <h2>Who's behind it</h2>
      <p>
        TelegramEmailBot is operated by <strong>Mii Global Partner Holdings Sdn. Bhd.</strong> (Company No. 202601028203 / 1690298-K), based in Penang, Malaysia. We're a small team obsessed with making business communication faster and less cluttered.
      </p>

      <p>
        Questions or feedback? Visit our <Link to="/contact">contact page</Link> or message us directly inside Telegram.
      </p>
    </LegalLayout>
  );
}
